<!--
 This component takes a list of entries, show the first large, the second medium, and the remainder small
 -->

<template>
  <div v-if="entries.length > 0">
    <div class="p-4 pt-6 bg-white sm:p-6 md:p-12 md:pt-8 md:border-b-2 md:border-solid md:border-app-lime md:rounded-xl">
      <h2 v-if="label" class="text-black text-lg font-bold leading-none uppercase md:text-xl lg:text-2xl xl:text-3xl" :class="{ 'mb-4 md:mb-8': !subtitle, 'mb-2': subtitle }">
        {{ label }}
      </h2>
      <h3 v-if="subtitle" class="text-black mb-4 md:mb-6">{{ subtitle }}</h3>
      <div class="grid gap-6 grid-cols-1 md:gap-8 md:grid-cols-12" :class="{ 'mb-6 md:mb-8': entries.length > 3 }">
        <div class="flex items-stretch md:col-span-6 md:row-end-3 md:row-start-1 lg:col-span-7">
          <slot name="large" :entry="entries[0]" />
        </div>
        <div class="grid gap-6 grid-rows-2 md:gap-8 md:col-span-6 md:row-end-3 md:row-start-1 lg:col-span-5">
          <template v-for="(entry, index) of entries.slice(1, 3)">
            <slot name="medium" :entry="entry" :index="index" />
          </template>
        </div>
      </div>
      <div v-if="entries.length > 3" class="grid gap-6 grid-cols-1 md:gap-8 md:grid-cols-2 lg:grid-cols-3">
        <template v-for="(entry, index) of entries.slice(3)">
          <slot name="small" :entry="entry" :index="index" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  entries: Array<any>
  label?: string | null
  subtitle?: string | null
}

defineProps<Props>()
</script>
